import { useState, useEffect } from "react";
import { GET_NEWS_BY_SLUG } from '../api/constants';

export const useNewsDetails = (slug) => {
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;

    const fetchNews = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(`${GET_NEWS_BY_SLUG}/${slug}`);
        const data = await response.json();

        if (data.status) {
          setNews(data.data || null);
        } else {
          setNews(null);
          setError(data.message || "News not found.");
        }
      } catch (err) {
        console.error("Error fetching news by slug:", err);
        setError("Failed to fetch news.");
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [slug]);

  return { news, loading, error };
};
